import w96 from "@/assets/timothy-ng-96.webp.asset.json";
import w144 from "@/assets/timothy-ng-144.webp.asset.json";
import w224 from "@/assets/timothy-ng-224.webp.asset.json";
import j96 from "@/assets/timothy-ng-96.jpg.asset.json";
import j144 from "@/assets/timothy-ng-144.jpg.asset.json";
import j224 from "@/assets/timothy-ng-224.jpg.asset.json";
import { cn } from "@/lib/utils";

const WEBP_SRCSET = `${w96.url} 96w, ${w144.url} 144w, ${w224.url} 224w`;
const JPEG_SRCSET = `${j96.url} 96w, ${j144.url} 144w, ${j224.url} 224w`;

const ALT = "Head and shoulders portrait of Timothy Ng, founder of Scryla, wearing a dark suit";

type PortraitProps = {
  /** CSS pixel size the image renders at on the largest breakpoint. */
  displaySize: number;
  className?: string;
  priority?: boolean;
};

export function Portrait({ displaySize, className, priority = false }: PortraitProps) {
  return (
    <picture>
      <source type="image/webp" srcSet={WEBP_SRCSET} sizes={`${displaySize}px`} />
      <img
        src={j144.url}
        srcSet={JPEG_SRCSET}
        sizes={`${displaySize}px`}
        alt={ALT}
        width={displaySize}
        height={displaySize}
        decoding="async"
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : "auto"}
        className={cn(
          "shrink-0 rounded-full border border-border object-cover object-top",
          className,
        )}
      />
    </picture>
  );
}
